const actions = {
  setToken({ commit }, payload) {
    commit('SET_TOKEN', payload);
  },

  setUser({ commit }, payload) {
    commit('SET_USER', payload);
  },

  setUserEmail({ commit }, payload) {
    commit('SET_USER_EMAIL', payload);
  },

  setPublicPages({ commit }, payload) {
    commit('SET_PUBLIC_PAGES', payload);
  },

  setEmailSuccess({ commit }, payload) {
    commit('SET_EMAIL_SUCCESS', payload);
  },

  setMenuAberto({ commit }, payload) {
    commit('SET_MENU_ABERTO', payload);
  },

  setDadosTransacao({ commit }, payload) {
    commit('SET_DADOS_TRANSACAO', payload);
  },

  setMotivosReembolso({ commit }, payload) {
    commit('SET_MOTIVOS_REEMBOLSO', payload);
  },

  setUrlAntesLogin({ commit }, payload) {
    commit('SET_URL_ANTES_LOGIN', payload);
  },

  setAssinaturaCancelada({ commit }, payload) {
    commit('SET_ASSINATURA_CANCELADA', payload);
  },

  setConcordouComVendedor({ commit }, payload) {
    commit('SET_CONCORDOU_COM_VENDEDOR', payload);
  },

  setRefreshingTokenPromise({ commit }, payload) {
    commit('SET_REFRESHING_TOKEN_PROMISE', payload);
  },

  setAlterarDadosBancarios({ commit }, payload) {
    commit('SET_ALTERAR_DADOS_BANCARIOS', payload);
  },

  setAlertaFormaPagamento({ commit }, payload) {
    commit('SET_ALTERAR_ALERTA_FORMA_PAGAMENTO', payload);
  },

  setReloadPage({ commit }, payload) {
    commit('SET_RELOAD_PAGE', payload);
  },

  setMenuLateral({ commit }, payload) {
    commit('SET_MENU_LATERAL', payload);
  },

  setAfiliadoProdutor({ commit }, payload) {
    commit('SET_AFILIADO_PRODUTOR', payload);
  },

  setDadosCompra({ commit }, payload) {
    commit('SET_DADOS_COMPRA', payload);
  },

  gravarDadosCompra({ dispatch }, dadosCompra) {
    const produtosEntrega = dadosCompra.shipping_address.products;
    const vendedorTelefone = dadosCompra.seller.phone;
    const vendedorWhatsapp = dadosCompra.seller.whatsapp;

    const dadosCompraStore = {
      venda: dadosCompra.id,
      vendedor: dadosCompra.seller.name,
      vendedorCentralDeAjuda: dadosCompra.seller.help_center,
      vendedorTelefone: vendedorTelefone ? vendedorTelefone.match(/\d+/g).join('') : null,
      vendedorWhatsapp: vendedorWhatsapp ? vendedorWhatsapp.match(/\d+/g).join('') : null,
      vendedorEmail: dadosCompra.seller.email,
      produto: dadosCompra.parent_product_name,
      plano: dadosCompra.parent_plan_name,
      valor: dadosCompra.total,
      data: dadosCompra.created_at,
      cardNumber: dadosCompra.credit_cards,
      reembolso: dadosCompra.is_refundable,
      boleto: dadosCompra.is_boleto,
      cartaoCredito: dadosCompra.is_credit_card,
      cartaoDebito: dadosCompra.is_debit_card,
      is_online_debt: dadosCompra.is_online_debt,
      is_pix: dadosCompra.is_pix,
      is_paypal: dadosCompra.is_paypal,
      is_boleto_in_installments: dadosCompra.is_boleto_in_installments,
      codigoReembolso: dadosCompra.refund_request_id,
      assinaturaStatus: dadosCompra.membership_status,
      reembolsoStatus: dadosCompra.refund_request_status_slug,
      possuiProdutoFisico: produtosEntrega.length > 0,
      possuiProdutoDigital: produtosEntrega.length < dadosCompra.products.length,
      dataProximaCobranca: dadosCompra.next_invoice_date,
      valorProximaCobranca: dadosCompra.next_invoice_amount,
      membership_is_boleto: dadosCompra.membership_is_boleto,
      membership_allows_boleto: dadosCompra.membership_allows_boleto,
      membership_change_payment_method: dadosCompra.membership_change_payment_method,
      codigoRastreio: dadosCompra.tracking_code,
      servicoRastreio: dadosCompra.tracking_service_slug,
      last_invoice_date: dadosCompra.last_invoice_date,
      status_slug: dadosCompra.status_slug,
      chat_room: dadosCompra.chat_room,
      produtos_order_bump: dadosCompra.products,
      total_order_bump_items: dadosCompra.total_order_bump_items,
      order_bump_assinatura_show_message: dadosCompra.order_bump_assinatura_show_message,
      order_bump_assinatura_parent_order: dadosCompra.order_bump_assinatura_parent_order,
      order_bump_assinatura_parent_product: dadosCompra.order_bump_assinatura_parent_product,
      currency_symbol: dadosCompra.currency_symbol,
    };

    dispatch('setDadosCompra', dadosCompraStore);
  },

  async buscarDadosRastreio({ commit }, {
    apiRastreio, recaptchaToken, codigoRastreio, namePath,
  }) {
    let rastreio = {};

    try {
      const { data } = await apiRastreio.track(
        recaptchaToken,
        codigoRastreio,
      );

      rastreio = {
        tracking_code: codigoRastreio,
        ...data,
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        throw new Error('Código de rastreio não encontrado. Favor verificar o código inserido.');
      } else {
        throw new Error('Ocorreu um erro inesperado. Acesse novamente mais tarde.');
      }
    }

    if (namePath !== 'acompanhar-envio-nao-logado' && (!rastreio.tracking_history || !rastreio.tracking_history.length)) {
      throw new Error('A transportadora ainda não atualizou o status da sua entrega. Acesse novamente mais tarde.');
    }

    commit('SET_RASTREIO', rastreio);
  },
};

export default {
  actions,
};
